import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { IconSizesEnum } from '../../../shared/components/icon/icons-sizes.enum';
import { IIcon } from '../../../shared/components/icon/icon.interface';
import { URLS } from '../../../shared/constants/urls.constant';
import { NavigationService } from 'i2g-ng-utils';
import { VerifyAccountDispatcher } from '../../../verify-account/verify-account.dispatcher';
import {
  I2gNgTrackingActionBuilder,
  ITrackingAction,
  ITrackingObject,
} from 'i2g-ng-tracking';
import { TrackingDispatcher } from '../../../tracking/tracking.dispatcher';

export const DIALOG_TYPE = 'onboarding-stripe';
const BUTTON_IDENTIFIER = 'resend_verification_email';

@Component({
  selector: 'app-enable-stripe-verification-dialog',
  templateUrl: './enable-stripe-verification-dialog.component.html',
  styleUrls: ['./enable-stripe-verification-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EnableStripeVerificationDialogComponent implements OnInit {
  @Input() trackingScreenName: string;
  @Input() trackingObject: ITrackingObject;

  trackingAction: ITrackingAction;

  dialogType: string;
  enabledStripeVerificationIcon: IIcon;

  constructor(
    private _verifyAccountDispatcher: VerifyAccountDispatcher,
    private _trackingActionBuilder: I2gNgTrackingActionBuilder,
    private _trackingDispatcher: TrackingDispatcher,
    private _navigationService: NavigationService
  ) {}

  ngOnInit() {
    this.dialogType = DIALOG_TYPE;
    this.enabledStripeVerificationIcon = {
      name: 'verify-email',
      size: IconSizesEnum.custom,
    };

    this.trackingAction = this._trackingActionBuilder.buildButtonTapped(
      BUTTON_IDENTIFIER,
      this.trackingScreenName
    );
  }

  onResendEmail() {
    this._trackingDispatcher.trackEvent(
      this.trackingObject,
      this.trackingAction
    );
    this._verifyAccountDispatcher.resendVerificationEmail();
  }

  goToLearnMore() {
    this._navigationService.goToExternalUrl(URLS.PAYMENTS_HELP_CARDS, true);
  }
}
